module.exports = __webpack_public_path__ + "static/img/honor20Pro.35bd3879.png";